var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"items":_vm.weekdays,"value":_vm.value},on:{"input":_vm.updateInput}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }